import React from 'react';
import { ArrowLeftRight, PiggyBank, TrendingUpDown, Receipt, Plus, ArrowDownUp } from 'lucide-react';

import './style.css';

const LabAnalysisOverviewCosts = ({
    simulatorData
}) => {
    return (
        <div className="lab-analysis-financial-details-item-costs">
            <div className="lab-analysis-financial-details-item-costs-header">
                <div className="lab-analysis-financial-details-item-costs-header-total-cost-icon-container">
                    <Receipt />
                </div>
                <div className="lab-analysis-financial-details-item-costs-header-total-cost">
                    <span>Est. Cost: {simulatorData.totals.totalCost.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                </div>
            </div>
            <div className="lab-analysis-financial-details-item-costs-breakdown">
                <span className="lab-analysis-financial-details-item-costs-breakdown-text">Labor: {simulatorData.totals.costLabor.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                <div className="lab-analysis-financial-details-item-costs-breakdown-icon-container small">
                    <Plus />
                </div>
                <span className="lab-analysis-financial-details-item-costs-breakdown-text">Materials: {simulatorData.totals.costMaterials.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
            </div>
        </div>
    )
}

export default LabAnalysisOverviewCosts;